/** @flow */

const responses = {
  POST: {
    "200": { status: "ok" }
  }
};

export default {
  users: { responses }
};
